module.exports = __webpack_public_path__ + "static/img/navBottomImg.e0d32493.png";